export default __webpack_public_path__ + "static/media/info.9f532ae1.svg";